// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f5aa7fd8","455":"3f0d090b","674":"d91cd40c","977":"d35724d6"}[chunkId] + ".chunk.js";
};